<template>
  <div class="detailCont" :style="{ zoom:scaled }">
  <div class="content-wrapper">
    <top></top>
    <div class="content">
      <div class="cont_title">{{ cname }}</div>
      <div class="cont_pdf">
        <ul v-if="content">
          <li v-html="content" style="cursor: text;"></li>
        </ul>
        <ul v-if="fileList.length>1">
          详情见附件:
          <li v-for="(item,index) in fileList" :key="item.fileid">
            <div class="list_txt">附件{{ index+1 }} <span style="margin-left: 15PX;">{{ item.appdesc }}</span></div>
            <div class="btn_box">
              <div class="list_btn">
                <a :href="item.appfile" :download="item.appdesc" @click="downClick(item)">下载</a>
              </div>
              <div class="list_btn" style="background-color: #caa06d !important;" v-if="item.type === 'pdf'" @click="filePreview(item.appfile)">预览</div>
            </div>
          </li>
        </ul>
        <ul class="preview" v-if="fileList.length === 1&&fileList[0].type === 'pdf'" style="margin-top: 20PX;">
          详情见附件:
          <div class="preFile">
            {{ fileList[0].appdesc }}
            <span class="down_btn">
              <a :href="fileList[0].appfile" @click="downClick(fileList)">下载</a>
            </span>
          </div>
          <li>
            <!-- <iframe :src="fileList[0].appfile" frameBorder=0 width="100%" height="900PX"></iframe> -->
            <div class="pdfbox">
              <pdf
                ref="pdf"
                v-for="item in numPages"
                :key="item"
                :src="fileList[0].appfile"
                :page="item"
                :scale="scale"
                >
              </pdf>
            </div>
          </li>
        </ul>
        <ul v-if="fileList.length === 1&&fileList[0].type !== 'pdf'">
          详情见附件:
          <li v-for="(item,index) in fileList" :key="item.fileid">
            <div class="list_txt">附件{{ index+1 }} <span style="margin-left: 15PX;">{{ item.appdesc }}</span></div>
            <div class="btn_box">
              <div class="list_btn">
                <a :href="item.appfile" :download="item.appdesc" @click="downClick(item)">下载</a>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="footers">
      <div class="footercont">
          主办：江苏省财政厅 备案序号：苏ICP备15009401号
          公安备案号：32010602010331 网站标识码：3200000098 江苏省财政厅版权所有
          <div class="jiucuo">
            <span id="_span_jiucuo">
              <img @click="Link('3200000003')" style="border:0;cursor: pointer;" src="../assets/jiucuonew.png">
            </span>
          </div>
          <div class="dzjg">
            <span id="_ideConac">
              <a href="https://bszs.conac.cn/sitename?method=show&amp;id=105DF988641221CBE053012819ACE317" target="_blank">
                <img id="imgConac" vspace="0" hspace="0" border="0" src="../assets/red.png"></a>
              </span>
            </div>
        </div>
    </div>
  </div>
    <el-dialog
      :visible.sync="fileDialog"
      :append-to-body="true"
      class="file_dialog">
      <div class="refbox">
        <!-- <iframe :src="curPdf" frameBorder=0 width="100%" height="800PX"></iframe> -->
        <pdf
          ref="pdfs"
          v-for="item in numPages"
          :key="item"
          :src="curPdf"
          :page="item"
          :scale="scale"
          >
        </pdf>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="fileDialog = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Pdf from 'vue-pdf'
import top from '../components/top.vue'
export default {
  name: 'detailsPage',
  components: {
    top,
    Pdf
  },
  data () {
    return {
      // 节点名称
      cname: '',
      fileList: [],
      fileDialog: false,
      curPdf: '',
      scale: 1,
      content: '',
      numPages: null,
      scaled: 1, // 初始缩放比例
      downList: []
    }
  },
  watch: {
    scaled: {
      handler (val) {
        window.addEventListener('load', this.handleResized)
      },
      deep: true,
      immediate: true
    },
    '$route.name': {
      handler (val) {
        this.handleResized()
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    getWindowSized () {
      return {
        width: window.innerWidth,
        height: window.innerHeight
      }
    }
  },
  mounted () {
    window.addEventListener('load', this.handleResized)
    window.addEventListener('resize', this.handleResized)
  },
  methods: {
    Link (sitecode) {
    // 该站点需要纠错页面的url地址
      var url = 'http://yjsgk.jsczt.cn/#/'
      // 跳转至纠错系统填写页面
      window.open('http://121.43.68.40/exposure/jiucuo.html?site_code=' + sitecode + '&url=' + encodeURIComponent(url))
    },
    downClick (item) {
      console.log(this.$route.query.year)
      let Year = this.$route.query.year
      if (Year === '自定义') {
        Year = localStorage.getItem('rangeyear')
      }
      // var downList=JSON.parse(decodeURIComponent(this.$route.query.list))
      var dwvalue = localStorage.getItem('ISdwname')
      // console.log(dwvalue)
      var paramsList = {
        browserVersion: navigator.appVersion,
        browserName: navigator.appName,
        browserLanguage: navigator.language,
        areaCode: this.downList.areacode,
        areaName: this.$route.query.areaName,
        deptCode: '',
        deptName: '',
        unitCode: '',
        unitName: '',
        areaYear: Year,
        sourceType: 5,
        fileType: this.$route.query.classinfoid,
        docId: item[0].appdocid,
        title: this.downList.title,
        channelId: this.downList.channelId,
        url: item[0].appfile,
        appendixId: item[0].fileid,
        appendixName: item[0].appdesc
      }
      if (this.$route.query.deptname && dwvalue !== 1) {
        // console.log(22221)
        paramsList.deptName = this.downList.deptname
        paramsList.deptCode = this.downList.deptcode
      }
      if (this.$route.query.deptname && dwvalue === 1) {
        // console.log(111)
        paramsList.deptCode = localStorage.getItem('bmcode')
        paramsList.deptName = localStorage.getItem('bmname')
        paramsList.unitCode = this.downList.deptcode
        paramsList.unitName = this.downList.deptname
      }
      this.$http.post('/yjsUbas/yjs/add', paramsList).then(res => {
        // if (res.data.code === 200) {
        // this.listData = res.data.data
      }
      )
    },
    handleResized () {
      var width = this.getWindowSized.width
      // 假设你设计稿的宽度是 1920PX
      var designWidth = 1920
      var scale = width / designWidth
      this.scaled = scale.toFixed(2)
      console.log(this.scaled)
    },
    // 详情
    async getDetail () {
      await this.$http.get('/api/yjsgk/findDataById', {
        params: {
          metadataId: this.$route.query.id
        }
      }).then(res => {
        if (res.data.code === 200) {
          this.downList = res.data.data
          console.log(res)
          this.cname = res.data.data.title
          this.content = res.data.data.content
          this.fileList = res.data.data.fileList
          this.fileList.forEach(item => {
            const lastIndex = item.appdesc.lastIndexOf('.')
            item.type = item.appdesc.substring(lastIndex + 1)
            this.getnumPages(item.appfile)
            item.count = this.numPages
          })
        }
      })
    },
    // 预览
    filePreview (url) {
      this.curPdf = url
      this.getnumPages(url)
      this.fileDialog = true
    },
    // 计算页数
    getnumPages (file) {
      let loadingTask = Pdf.createLoadingTask(file)
      console.log(loadingTask)
      loadingTask.promise.then(Pdf => {
        this.numPages = Pdf.numPages
      }).catch(err => {
        console.log(err)
      })
    }
  },
  created () {
    this.getDetail()
  }
}
</script>
<style scoped>
@import url('../assets/overview.css');
.detailCont{
  /* width: 1920PX; */
  position: relative;
  background: #f7fafd;
  margin: 0 auto;
  height: 100%;
}
.content {
  position: relative;
  margin-top: 50PX;
  padding-bottom: 168PX;
}
.cont_title {
  text-align: center;
  font-size: 24PX;
  font-weight: bold;
}
.cont_pdf {
  width: 1040PX;
  margin: 0 auto;
  margin-top: 30PX;
}
.preview{
  width: 1040PX;
  margin: 0 auto;
}
.pdfbox{
  width: 100%;
  height: 900PX;
  overflow: scroll;
}
.refbox{
  width: 100%;
  height: 700PX;
  overflow: scroll;
}
.cont_pdf ul li{
  font-size: 18PX;
  font-weight: 400;
  color: #161616;
  position: relative;
  cursor: pointer;
  background: rgba(152, 163, 195, 0.1);
  padding: 10PX;
  margin-top: 10PX;
}
.list_txt{
  width: 80%;
}
.cont_pdf ul li div {
  display: inline-block;
}
.list_btn{
  width: 48PX;
  background: #1c6493;
  border-radius: 6PX;
  line-height: 30PX;
  color: #ffffff;
  padding-left: 10PX;
  margin-left: 12%;
  cursor: pointer;
}
.list_btn a{
  color: #fff;
  cursor: pointer;
}
.down_btn{
  display: inline-block;
  width: 48PX;
  background: #1c6493;
  border-radius: 6PX;
  line-height: 30PX;
  margin-left: 20PX;
  text-align: center;
  padding-right: 2PX;
  cursor: pointer;
}
.down_btn a{
  color: #ffffff;
  cursor: pointer;
}
.file_dialog /deep/ .el-dialog{
  background: none !important;
  box-shadow: none !important;
}
.file_dialog /deep/ .el-dialog__header {
  display: none !important;
}
.file_dialog /deep/ .el-dialog__body {
  padding: 0PX !important;
}
.btn_box{
  width: 200PX;
}
.footers {
  width: 100%;
  height: 100PX;
  background: #1c6493;
  position: absolute;
  bottom: 0;
  font-size: 16PX;
  font-weight: 400;
  color: #fafbfc;
  line-height: 100PX;
  text-align: center;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/views/detailsPage.vue